import { createSelector } from 'reselect';
import Constants from '../config/const';

import { workSizeDetails } from './work_sizes';

const PADDING = {
  left: 2,
  right: 2,
  bottom: 2,
  top: 2
};

const cropSelector = ({ crop }) => crop;

const calculatePositions = (works, crop, padding) => {
  const {
    x: cX, y: cY, width: cWidth, height: cHeight, custom
  } = crop;

  let minx = null;
  let miny = null;
  let maxx = null;
  let maxy = null;
  let noData = false;
  works.forEach((work) => {
    const x = parseFloat(work.x);
    const y = parseFloat(work.y);
    const { previewW, previewH } = work;
    if (previewW && previewH) {
      if (minx === null || minx > x) { minx = x; }
      if (maxx === null || maxx < x + previewW) { maxx = x + previewW; }
      if (miny === null || miny > y) { miny = y; }
      if (maxy === null || maxy < y + previewH) { maxy = y + previewH; }
    } else {
      noData = true;
    }
  });

  if (noData) { return {}; }

  if (custom) {
    return {
      x: cX,
      y: cY,
      width: cWidth,
      height: cHeight
    };
  }

  const base = {
    x: minx - (padding.left || 0),
    y: miny - (padding.top || 0),
    width: maxx - minx + (padding.left || 0) + (padding.right || 0),
    height: maxy - miny + (padding.top || 0) + (padding.bottom || 0)
  };

  const { scaleX, scaleY } = Constants.preview;
  const dw = base.width / scaleX;
  const dh = base.height / scaleY;
  let shiftX = 0;
  let shiftY = 0;
  if (dw < dh) {
    shiftX = ((scaleX / scaleY) * base.height - base.width) / 2;
  } else {
    shiftY = ((scaleY / scaleX) * base.width - base.height) / 2;
  }

  base.x -= shiftX;
  base.y -= shiftY;
  base.width += 2 * shiftX;
  base.height += 2 * shiftY;

  return base;
};

export const automaticPreview = createSelector(
  workSizeDetails, cropSelector, (works, crop) => calculatePositions(works, crop, PADDING)
);

export const hangingPreview = createSelector(
  workSizeDetails, (works) => {
    const {
      x, y, width, height
    } = calculatePositions(works, { custom: false }, {});
    const top = height * 0.2;
    const bottom = height * 0.4;
    const left = width * 0.6;
    const right = width * 0.02;
    const previewConfig = {
      x: x - left,
      width: width + left + right,
      y: y - top,
      height: height + top + bottom
    };
    const markPositions = {
      top: top / 2,
      bottom: height + bottom + (top / 2),
      left: left - right,
      right: width + left + (right / 2),
      groundLeft: left - (right / 2)
    };
    return { previewConfig, markPositions };
  }
);
